module.exports = __webpack_public_path__ + "static/media/cam.efcc062b.png";